import React from "react";
import * as Icons from "lucide-react";
import { WHY_US } from "../data/products";
import Reveal from "./Reveal";

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="relative py-24 md:py-32 bg-[#080808] border-y border-[#161616]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#737373] mb-4">
                Standards
              </div>
              <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] text-[#F5F5F5]">
                Why <span className="text-stroke">Sandform</span>
              </h2>
            </div>
            <p className="text-[#A3A3A3] max-w-sm text-sm md:text-base">
              We don't cut corners so you don't have to compromise. This is the infrastructure behind every vial.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-[#1c1c1c]">
          {WHY_US.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Circle;
            return (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <div
                  data-testid={`why-us-item-${i}`}
                  className="group relative h-full border-r border-b border-[#1c1c1c] p-8 md:p-10 hover:bg-[#0f0f0d] transition-colors duration-500"
                >
                  <Icon size={26} className="text-[#E6DFD4] mb-8" strokeWidth={1.5} />
                  <h3 className="font-display text-2xl md:text-3xl uppercase leading-none text-[#F5F5F5] mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-[#A3A3A3] leading-relaxed">{item.desc}</p>
                  <span className="absolute top-8 right-8 font-display text-lg text-[#2c2c2c]">
                    0{i + 1}
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
